export default (render) => (text, record, index) => {
    const { rowSpan, colSpan } = record;
    return {
        children: render ? render(text, record, index) : text,
        props: {
            rowSpan: rowSpan != undefined ? rowSpan : 1,
            colSpan: colSpan != undefined ? colSpan : 1,
        }
    };
}


// WEBPACK FOOTER //
// ./src/components/shared/renderEnhancer.js